























import PageContainer from '@/general/component/PageContainer.vue';
import Component from 'vue-class-component';
import CustomerRouter, {customerRouter} from '@/context/customer/router/CustomerRouter';
import {AxiosResponse} from 'axios';
import {customerApi} from '@/context/customer/api/CustomerApi';
import {CustomerFilter} from '@/context/customer/model/CustomerFilter';
import Vue from 'vue';
import {Api} from '@/common/api/Api';
import TextInput from '@/general/component/form/input/TextInput.vue';
import RemoteConfigurationRouter
  , {
  remoteConfigurationRouter
} from "@/context/remote_configuration/router/RemoteConfigurationRouter";
import {
  RemoteConfigurationFilter
} from "@/context/remote_configuration/model/RemoteConfigurationFilter";
import {
  RemoteConfigurationApi,
  remoteConfigurationApi
} from "@/context/remote_configuration/api/RemoteConfigurationApi";
import {VModel} from "vue-property-decorator";
import {UploadFormModel} from "@/context/remote_configuration/model/UploadFormModel";
import {IdResponse} from "@/common/model/IdResponse";
import RemoteConfigurationDownloadFormTemplate
  from "@/context/remote_configuration/components/RemoteConfigurationDownloadFormTemplate.vue";
import FormBase from "@/general/abstract/form/FormBase.vue";
import {DownloadFormModel} from "@/context/remote_configuration/model/DownloadFormModel";

@Component({
  components: {FormBase, RemoteConfigurationDownloadFormTemplate, TextInput}
})
export default class RemoteConfigurationDownloadListContainer extends Vue {
  loading = false;
  api: RemoteConfigurationApi = remoteConfigurationApi;
  submitting = false;
  @VModel({default: new DownloadFormModel()}) model!: DownloadFormModel;


  async submit(): Promise<IdResponse> {

    try {
      const response = await RemoteConfigurationApi.downloadConfiguration(this.model)
      // Create a URL for the file
      console.log(response);
      const url = window.URL.createObjectURL(new Blob([response], {type: 'application/json'}));

      // Create a link element
      const link = document.createElement('a');
      link.href = url;

      // Set the download attribute with a filename
      link.setAttribute('download', `${this.model.identifier}.json`);

      // Append the link to the body (required for Firefox)
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Clean up the DOM after download
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading the file:", error);
      // Handle error (e.g., show an error message)
    }
    return Promise.resolve(new IdResponse(-1))
  };

  async goBack() {
  }
}
